/**
 * The note a channel-partner company sees wherever a price or checkout would
 * be (#943, #956): subscription page, plans, Coin packs. One `cyber-card`
 * with a header and an empty-state body, so every place says the same thing
 * the same way. No prices, no buttons to buy.
 */
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PARTNER_PLAN_MESSAGE } from '@core/utils/channel-partner';

@Component({
  selector: 'app-partner-plan-note',
  templateUrl: './partner-plan-note.component.html',
  styleUrl: './partner-plan-note.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PartnerPlanNoteComponent {
  /** The partner's name, when the company record has one. */
  @Input() partnerName: string | null = null;

  /** Card title, e.g. "Your plan" or "Coin packs". */
  @Input() heading = 'Your plan';

  /** One line under the title. */
  @Input() subheading = 'Managed by your partner';

  /** Compact: no card chrome, for a section that already has a header. */
  @Input() compact = false;

  readonly message = PARTNER_PLAN_MESSAGE;
}
